import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { EpcotModule } from '../../../../common/epcot-config.service';
import { PairGameScoreboardStats } from '../../../../scoreboards/models/scoreboard-stats';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './my-bets-pair-scoreboard-stats.html',
    selector: 'ms-my-bets-pair-scoreboard-stats',
})
export class MyBetsPairScoreboardStatsComponent {
    private trackingService = inject(TrackingService);

    vm = input.required<PairGameScoreboardStats>();
    isExpandable = input<boolean>(false);
    isExpanded = input<boolean>(false);
    isExpandedChanged = output<boolean>();
    module = EpcotModule.MyBetsBetSlip;

    onExpandCollapse(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.isExpandedChanged.emit(!this.isExpanded());
        this.trackingService.track(trackingConstants.EVENT_PAGE_VIEW, {
            [trackingConstants.PAGE_NAME]: !this.isExpanded() ? 'myBets_StatsON' : 'myBets_StatsOff',
        });
    }
}
